<template>
    <div class="banner" data-aos="fade-right">
        <h2 class="banner-heading">{{ category }}</h2>
        <p class="banner-article">{{ category }} are making from the high-quality materials. Complete your style with
            help them.</p>
    </div>
</template>

<script>
export default {
    props: {
        category: {
            type: String,
            default: 'All items'
        }
    }
}
</script>

<style scoped>
.banner {
    background-image: url('/public/images/banner.png');
    background-size: cover;
    background-repeat: no-repeat;
    background-position: top top;
    padding: 30px 60px;
    height: 285px;

    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    gap: 20px;
}

.banner-heading {
    color: #FFF;
    font-family: "Glusp";
    font-size: clamp(2.2rem, 5vw, 3.8rem);
    font-weight: 700;
}

.banner-article {
    color: #FFF;
    font-family: "Mabry Pro";
    font-size: clamp(1.8rem, 3vw, 2.8rem);
    font-weight: 300;
    max-width: 680px;
}
</style>